<template>
    <div id="datatable-planning-backoffice">
        <v-data-table
            :headers="headers"
            :items="listUsers"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 20, 50]
            }"
            dense
        >

        <template v-slot:item.isActive="props">
            <v-chip
                :color="getColor(props.item.isActive)"
                pill
                dark
                small
                class="status-column"
            >
                {{props.item.isActive ? $t('backoffice.general.active-status') : $t('backoffice.general.inactive-status')}}
            </v-chip>
        </template>

        <template v-slot:item.isProductive="props">
                 <span> {{props.item.isProductive ? $t('backoffice.modules-management.planning.datatable-list-users.productive') : $t('backoffice.modules-management.planning.datatable-list-users.user')}} </span>
        </template>

        <template v-slot:item.config="props">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span style="cursor: pointer;" class="mr-2 p-0" @click="onConfigClicked(props.item)" v-bind="attrs" v-on="on">
                        <img src="/images/_SVGs/bo/edit_pencil.svg" alt="configurar" onload="SVGInject(this)" width="20" height="20" />
                    </span>
                </template>
                <span>{{props.item.isProductive ? $t('backoffice.modules-management.planning.datatable-list-users.edit-productive') : $t('backoffice.actions.config') }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="!props.item.isPlanningAssociate">
                <template v-slot:activator="{ on, attrs }">
                    <span style="cursor: pointer;" class="mr-2 p-0" @click="onDeleteClicked(props.item)" v-bind="attrs" v-on="on">
                        <img src="/images/_SVGs/bo/remove.svg" alt="remover" onload="SVGInject(this)" width="15" height="20" class="circle"/>
                    </span>
                </template>
                <span>{{$t('backoffice.modules-management.planning.datatable-list-users.remove-productive')}}</span>
            </v-tooltip>
                <template v-else>
                    <span style="cursor: no-drop !important;" class="mr-2 p-0" @click="modalAlert.show = true">
                        <img src="/images/_SVGs/bo/remove-block.svg" alt="remover" onload="SVGInject(this)" width="15" height="20" class="circle nodrop"/>
                    </span>
                </template>
        </template>

        </v-data-table>

        <base-modal v-model="modalAlert.show" modalAlign="align__flex--center" :title="modalAlert.title" modal-width="460px" :iconColor="modalAlert.iconColor" :iconName="modalAlert.iconName">
            <template v-slot:modal-body>
                {{modalAlert.message}}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn class="primary-button" text @click="modalAlert.show = false">
                        {{ $t('backoffice.actions.ok') }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {BaseModal},
    props: {
        listUsers: Array | Object,
        searchCount: Number,
        totalItems: Number | String
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t('backoffice.modules-management.planning.datatable-list-users.headers.name'),
                    align: "start",
                    value: "fullName",
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.modules-management.planning.datatable-list-users.headers.garage'),
                    align: "start",
                    value: "garageName",
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.modules-management.planning.datatable-list-users.headers.status'),
                    align: "center",
                    value: "isActive",
                    width: '10%',
                    class: "header-table-color",
                },
                {
                    text: "",
                    value: "config",
                    sortable: false,
                    align: "right",
                    class: "header-table-color",
                },
            ],
            page: 1,
            numberOfPages:0,
            options: {
                page: 1,
                itemsPerPage: 10
            },
            modalAlert: {
                show: false,
                title: this.$t('backoffice.modules-management.planning.datatable-list-users.modal-alert-title'),
                message: this.$t('backoffice.modules-management.planning.datatable-list-users.modal-alert-msg'),
                iconName: 'mdi-alert-outline',
                iconColor: 'warning',
            },
        };
    },
    watch: {
      "options.page": {
        handler() {
          this.$emit('alterTable', this.options);
        },
      },
      "options.itemsPerPage": {
        handler() {
          this.$emit('alterTable', this.options);
        },
      },
      "options.sortBy":{
        handler() {
            this.$emit('alterTable', this.options);
        },
      },
      searchCount:{
        handler() {
          this.options.page = 1
        },
      },
    },
    methods: {

        onConfigClicked(item) {
            this.$emit("config-clicked", { item });
        },

        getColor(status) {
            if (status == true) return "green";
            else if (status == false) return "red";
            else return "orange";
        },

        onDeleteClicked(item) {
            this.$emit("delete-clicked", { item });
        },
    }
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-planning-backoffice {
    .status-column {
        width: 50%;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 5px;
        margin-top: 5px;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        @media (max-width: 599px) {
            display: block !important;
        }
        .service{
            @media (max-width: 599px) {
                float: left;
            }
        }
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 10px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }
    .star {
        color: #ffc117 !important;
    }

    .bold-style {
        font-weight: bold;
    }

    .v-data-footer {
        margin-right: 40px !important;
    }

    .btn-show-hours {
        width: 14rem;
        text-transform: initial;
        color: white;
        background-color: var(--v-primary-base);
    }

}
#public-btn {
    width: 14rem;
    text-transform: initial;
    color: white;
    background-color: var(--v-primary-base) !important;
}


.v-menu__content[role=menu] {
   .v-small-dialog__content {
        padding: 0 !important;
    }
}

.theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
    left: 1110px !important;
}

@media (max-width: 1025px) {
    .theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
        left: 780px !important;
    }
}

@media (min-width: 1450px) and (max-width: 1439px){
    .theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
        left: 1360px !important;
    }
}

@media (min-width: 2559px) {
    .theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
        left: 1704px !important;
    }
}

.nodrop {
    cursor: no-drop !important;
}

</style>
